import { cx } from '@/utils/strings'

interface ShieldLoaderProps {
  containerHeight?: string | number
  shieldSize?: string
  className?: string
}

export default function ShieldLoader({ containerHeight, shieldSize, className }: ShieldLoaderProps) {
  return (
    <div className={`w-full flex justify-center items-center`} style={{ height: `${containerHeight}px` }}>
      <span
        className={cx(
          'animate-[beat_1.8s_ease-in-out_infinite] font-bwi text-primaryBlue',
          shieldSize == undefined && 'text-[100px]',
          shieldSize === 'Xsmall' && 'text-[20px]',
          shieldSize === 'Small' && 'text-[50px]',
          shieldSize === 'Medium' && 'text-[125px]',
          shieldSize === 'Large' && 'text-[150px]',
          className
        )}
      >
        &#xe932;
      </span>
    </div>
  )
}
